import { render, staticRenderFns } from "./ViewCouponBox.vue?vue&type=template&id=47e12012&"
import script from "./ViewCouponBox.vue?vue&type=script&lang=js&"
export * from "./ViewCouponBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports